/* 
 * This demonstrates how an external script can listen for slideActivated events on a single, specific
 * decision tool and react to them. The point of having this in a separate file is to show how the main 
 * decision-tool.js file might be bundled with the CDP or some other distribution of that nature that is
 * installed across multiple sites, with a standalone script like this appearing on individual sites to 
 * implement journey-specific logic.
 */

document.addEventListener('DOMContentLoaded', function () {

    // Wait for slides to be activated
    document.addEventListener('slideActivated', function (event) {
        const slideId = event.detail.slideId;

        switch (slideId) {
            case 's4a':

                // Hide the "Other" text input on slide 4a on slide activation
                document.querySelector('#reasonsfordecisionother').closest('.j6csq-decision-tool-element-single_line_text_input').style.display = 'none';

                // Populate the summary page focus field based on the user's selection on the previous slide
                document.getElementById('j6csq-financialdt-summary-focus').innerHTML = document.getElementById('focuspay').innerHTML;
                break;

            case 's4b':

                // Populate the summary page focus field based on the user's selection on the previous slide
                document.getElementById('j6csq-financialdt-summary-focus').innerHTML = document.getElementById('focusquit').innerHTML;

                // Hide the "Other" text input on slide 4b on slide activation
                document.querySelector('#motivationfordecisionothertext').closest('.j6csq-decision-tool-element-single_line_text_input').style.display = 'none';
                break;

            // Final summary screen
            case 's22b':

                // Get the checked status of the three checkboxes
                const checkbox1 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Impact on your Income + Expenses"]').checked;
                const checkbox2 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Effect on your Savings + Retirement"]').checked;
                const checkbox3 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Balancing your Work + Life Responsibilities"]').checked;

                // show and hide result subsections based on the checkboxes
                j6csqShowHideSectionsBySelector('.j6csq-financialdt-summary-results-income', checkbox1);
                j6csqShowHideSectionsBySelector('.j6csq-financialdt-summary-results-savings', checkbox2);
                j6csqShowHideSectionsBySelector('.j6csq-financialdt-summary-results-worklife', checkbox3);

                // show and hide the Actions to Consider subsections based on the checkboxes
                j6csqShowHideSectionsBySelector('#j6csq-financialdt-summary-actions-to-consider-income', checkbox1);
                j6csqShowHideSectionsBySelector('#j6csq-financialdt-summary-actions-to-consider-savings', checkbox2);
                j6csqShowHideSectionsBySelector('#j6csq-financialdt-summary-actions-to-consider-worklife', checkbox3);
                
                // Set the three "Actions to Consider" UL lists to empty for starters
                document.querySelector('#j6csq-financialdt-summary-actions-to-consider-income ul').innerHTML = '';
                document.querySelector('#j6csq-financialdt-summary-actions-to-consider-savings ul').innerHTML = '';
                document.querySelector('#j6csq-financialdt-summary-actions-to-consider-worklife ul').innerHTML = '';


                // 1 of 3: Populate the "Actions to Consider" list for Income
                if (checkbox1) {

                    let thingsToConsider = [];

                    // Get value of ids incomeslider1 through incomeslider7.  
                    // For each one whose value is 1, get the corresponding label and add it to the array
                    for (let i = 1; i <= 7; i++) {
                        const slider = document.getElementById(`incomeslider${i}`);
                        if (slider.value === '1') {
                            thingsToConsider.push(document.querySelector(`label[for="incomeslider${i}"]`).textContent);
                        }
                    }

                    thingsToConsider.push('Another thing to keep in mind: If you retire and start getting Social Security benefits before your full retirement age, there\'s a limit to how much you can earn if you decide to go back to work. If you earn more than the limit ($21,240 in 2023), you\'ll have penalties deducted from your Social Security payments.');

                    // populate the ul list
                    const ul = document.querySelector('#j6csq-financialdt-summary-actions-to-consider-income ul');

                    if (thingsToConsider.length) {
                        thingsToConsider.forEach(function (item) {
                            const li = document.createElement('li');
                            li.textContent = item.replace(' (Required)', '');
                            ul.appendChild(li);
                        });
                    }
                }

                // 2 of 3: Populate the "Actions to Consider" list for Savings
                if (checkbox2) {

                    let thingsToConsider = [];

                    thingsToConsider.push('Talk to a financial planner');
                    thingsToConsider.push('Higher income translates to a bigger Social Security benefit when you retire, so if you quit your full-time job, you should figure out what that will mean to your wallet. Your Social Security benefit is based on the average amount of money you made each month during your 35 highest-earning years, adjusted for inflation. If you’re one of the 40% of people over 65 who get at least half of their income from Social Security, then a lower benefit means less money later in life.');

                    // populate the ul list
                    const ul = document.querySelector('#j6csq-financialdt-summary-actions-to-consider-savings ul');

                    if (thingsToConsider.length) {
                        thingsToConsider.forEach(function (item) {
                            const li = document.createElement('li');
                            li.textContent = item.replace(' (Required)', '');
                            ul.appendChild(li);
                        });
                    }
                }

                // 3 of 3: Populate the "Actions to Consider" list for Work/Life Balance
                if (checkbox3) {

                    let thingsToConsider = [];

                    // Get a list of all checkboxes with the name "worklifecheck" and add the checked ones to the array
                    document.querySelectorAll('input[name="worklifecheck"]').forEach(function (checkbox) {
                        if (checkbox.checked) {
                            thingsToConsider.push(checkbox.value);
                        }
                    });

                    thingsToConsider.push('You may want to take a look at this article from AARP by Dr. Barry Jacobs: <a href="https://www.aarp.org/caregiving/basics/info-2024/embrace-new-life-after-caregiving.html" target="_blank" rel="noopener noreferrer">How Family Caregiving Can Alter Dreams and Goals Deferred</a>.');

                    // populate the ul list
                    const ul = document.querySelector('#j6csq-financialdt-summary-actions-to-consider-worklife ul');

                    if (thingsToConsider.length) {
                        thingsToConsider.forEach(function (item) {
                            const li = document.createElement('li');
                            if (item.includes('<a ')) {
                                // If the item contains an anchor tag, set the innerHTML
                                li.innerHTML = item;
                            } else {
                                // Otherwise, set the textContent
                                li.textContent = item.replace(' (Required)', '');
                            }
                            ul.appendChild(li);
                        });
                    }
                }

                break;
        }
    });

    // Here we listen for checkbox changes on slide 8b and react accordingly
    document.querySelectorAll('#financialdt input[name="s8bcheckboxes"]').forEach(function (checkbox) {

        checkbox.addEventListener('change', function (event) {

            // Get the checked status of the three checkboxes
            const checkbox1 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Impact on your Income + Expenses"]').checked;
            const checkbox2 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Effect on your Savings + Retirement"]').checked;
            const checkbox3 = document.querySelector('#financialdt input[name="s8bcheckboxes"][value="Balancing your Work + Life Responsibilities"]').checked;

            // Set the start button target based on the checkboxes
            const buttonStart = document.getElementById('bmultipathstart');
            if (checkbox1) {
                buttonStart.setAttribute('data-action', 'jumpforward');
                buttonStart.setAttribute('data-action-target', 's9b'); // jump to start of path 1
                buttonStart.disabled = false;
            } else if (checkbox2) {
                buttonStart.setAttribute('data-action', 'jumpforward');
                buttonStart.setAttribute('data-action-target', 's13b'); // jump to start of path 2
                buttonStart.disabled = false;
            } else if (checkbox3) {
                buttonStart.setAttribute('data-action', 'jumpforward'); // jump to start of path 3
                buttonStart.setAttribute('data-action-target', 's17b');
                buttonStart.disabled = false;
            } else {
                buttonStart.setAttribute('data-action', 'noaction'); // nothing selected so button is disabled
                buttonStart.setAttribute('data-action-target', '');
                buttonStart.disabled = true;
            }

            const buttonPath1End = document.getElementById('bmultipath1end');
            if (checkbox2) {
                buttonPath1End.setAttribute('data-action', 'jumpforward');
                buttonPath1End.setAttribute('data-action-target', 's13b'); // jump to start of path 2
            } else if (checkbox3) {
                buttonPath1End.setAttribute('data-action', 'jumpforward'); // jump to start of path 3
                buttonPath1End.setAttribute('data-action-target', 's17b');
            } else {
                buttonPath1End.setAttribute('data-action', 'jumpforward'); // nothing selected so button is disabled
                buttonPath1End.setAttribute('data-action-target', 's22b'); // proceed to final summary
            }

            const buttonPath2End = document.getElementById('bmultipath2end');
            if (checkbox3) {
                buttonPath2End.setAttribute('data-action', 'jumpforward'); // jump to start of path 3
                buttonPath2End.setAttribute('data-action-target', 's17b');
            } else {
                buttonPath2End.setAttribute('data-action', 'jumpforward'); // nothing selected so button is disabled
                buttonPath2End.setAttribute('data-action-target', 's22b'); // proceed to final summary
            }

            // We don't need to specify buttonPath3End as it always points to s22b
        });
    });

    // Listen for the "Other" checkbox on slide 4a to change and react accordingly
    document.querySelectorAll('#financialdt input[name="reasonsfordecision"][value="Other"]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function (event) {
            // Get the checked status of the "Other" checkbox
            const checkboxOther = event.target.checked;

            // Show or hide the "Other" text input based on the checkbox status
            document.querySelector('#reasonsfordecisionother').closest('.j6csq-decision-tool-element-single_line_text_input').style.display = checkboxOther ? 'block' : 'none';
        });
    });

    // Listen for the "Other" checkbox on slide 4b to change and react accordingly
    document.querySelectorAll('#financialdt input[name="motivationfordecision"][value="Other"]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function (event) {
            // Get the checked status of the "Other" checkbox
            const checkboxOther = event.target.checked;

            // Show or hide the "Other" text input based on the checkbox status
            document.querySelector('#motivationfordecisionothertext').closest('.j6csq-decision-tool-element-single_line_text_input').style.display = checkboxOther ? 'block' : 'none';
        });
    });

});

function j6csqShowHideSectionsBySelector(thisSelector, visible) 
{
    document.querySelectorAll(thisSelector).forEach(function (div) {
        div.style.display = visible ? 'block' : 'none';
    });
}